import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { UserAccessGroup } from "lib/@components/user-access/user-access-group"
import { getAllowedRegimeUsers } from "../controller/get-allowed-regime-users"

export function RegimeUserAccessGroup() {
    const { parentItem } = useBoundContext()
    const users = getAllowedRegimeUsers.useResults(parentItem.id)
    return <UserAccessGroup users={users} applyLimit={3} />
}
